module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/archive/archive-show/archive-show.component.scss
// module id = ./src/app/views/setting/archive/archive-show/archive-show.component.scss
// module chunks = main